import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-selected"];
const _hoisted_2 = { class: "flex flex-1 flex-col" };
const _hoisted_3 = { class: "flex items-center gap-1" };
const _hoisted_4 = { class: "text-sm font-semibold text-(--colors-text-body)" };
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = { class: "text-sm text-(--colors-text-body)" };
import { Tooltip } from "@eudonet/opal";
import AdvancedFilterRowMenu from "./AdvancedFilterRowMenu.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdvancedFilterLibraryItem',
    props: {
        item: {},
        selected: { type: Boolean },
        tooltipText: {}
    },
    emits: ["select", "request-tooltip", "edit", "rename", "delete", "manage-access"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function onInfoInteract() {
            emit("request-tooltip");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                role: "option",
                "aria-selected": props.selected,
                tabindex: "0",
                class: _normalizeClass(["flex cursor-pointer items-center gap-[14px] rounded-xl border border-(--colors-border-base-medium) bg-(--colors-background-white) p-[14px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-(--colors-border-accent)", props.selected ? 'ring-2 ring-(--colors-border-accent)' : '']),
                onClick: _cache[6] || (_cache[6] = ($event) => (emit('select'))),
                onKeydown: [
                    _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event) => (emit('select')), ["prevent"]), ["enter"])),
                    _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event) => (emit('select')), ["prevent"]), ["space"]))
                ]
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(props.item.name), 1 /* TEXT */),
                        _createVNode(_unref(Tooltip), {
                            text: props.tooltipText,
                            position: "top"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("button", {
                                    type: "button",
                                    "data-testid": "filter-info-button",
                                    class: "inline-flex items-center text-(--colors-text-body-subtle)",
                                    "aria-label": _ctx.$t('advancedFilterLibrary.tooltip.ariaLabel'),
                                    onClick: _withModifiers(onInfoInteract, ["stop"]),
                                    onFocus: onInfoInteract,
                                    onMouseenter: onInfoInteract,
                                    onKeydown: [
                                        _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => { }, ["stop"]), ["enter"])),
                                        _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["stop"]), ["space"]))
                                    ]
                                }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("i", {
                                            class: "ri-information-line text-[14px]",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */)
                                    ]))], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["text"])
                    ]),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(props.item.meta), 1 /* TEXT */)
                ]),
                (props.item.canEdit || props.item.canDelete || props.item.canManageAccess)
                    ? (_openBlock(), _createBlock(AdvancedFilterRowMenu, {
                        key: 0,
                        "can-edit": props.item.canEdit,
                        "can-delete": props.item.canDelete,
                        "can-manage-access": props.item.canManageAccess,
                        onEdit: _cache[2] || (_cache[2] = ($event) => (emit('edit'))),
                        onRename: _cache[3] || (_cache[3] = ($event) => (emit('rename'))),
                        onDelete: _cache[4] || (_cache[4] = ($event) => (emit('delete'))),
                        onManageAccess: _cache[5] || (_cache[5] = ($event) => (emit('manage-access')))
                    }, null, 8 /* PROPS */, ["can-edit", "can-delete", "can-manage-access"]))
                    : _createCommentVNode("v-if", true)
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
